module.exports = __webpack_public_path__ + "img/www.zomato.com.4f9f27dd.png";